import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface TimeSlotPickerProps {
  availableTimeSlots: string[];
  selectedTimeSlot: string;
  onSelectTimeSlot: (timeSlot: string) => void;
}

// Export as both named export and default export to ensure compatibility
export function TimeSlotPicker({
  availableTimeSlots,
  selectedTimeSlot,
  onSelectTimeSlot,
}: TimeSlotPickerProps) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {availableTimeSlots.map((timeSlot) => (
        <Button
          key={timeSlot}
          type="button"
          variant="outline"
          className={cn(
            'h-10 px-3',
            selectedTimeSlot === timeSlot && 'bg-primary text-primary-foreground'
          )}
          onClick={() => onSelectTimeSlot(timeSlot)}
        >
          {timeSlot}
        </Button>
      ))}
    </div>
  );
}

// Add default export for the same component
export default TimeSlotPicker; 